import { styled } from "@mui/material/styles";
import { colors } from "../../styles";

const Page = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  background: colors.off_white,
}));

export default Page;
